import React from 'react';
import { Link } from 'react-router-dom';
import { getUniverseForumsPath } from '../../../utils/universePaths';
import styles from '../Dashboard.module.css';

const DashboardQuickActions = ({ canCreateFaction, canUseAiScenes, universeSlug }) => {
  const forumsLink = getUniverseForumsPath(universeSlug);

  return (
    <section className={styles.quickActionsSection}>
      <header className={styles.quickActionsHeader}>
        <h2 className={styles.quickActionsTitle}>Actions rapides</h2>
      </header>
      <div className={styles.quickActions}>
        <Link to="/characters/new" className={styles.quickAction}>Créer un personnage</Link>
        <Link to={forumsLink} className={styles.quickAction}>Créer une scène</Link>
        {canCreateFaction && (
          <Link to="/factions/new" className={styles.quickAction}>Créer une faction</Link>
        )}
        {canUseAiScenes && (
          <Link to="/scenes-ia" className={styles.quickAction}>Scènes IA</Link>
        )}
        <Link to="/factions" className={styles.quickAction}>Voir les factions</Link>
        <Link to={forumsLink} className={styles.quickAction}>Toutes les scènes</Link>
        <Link to="/messagerie" className={styles.quickAction}>Messagerie</Link>
      </div>
    </section>
  );
};

export default DashboardQuickActions;
